import { Subscription } from 'db-tables'
import { supabaseClient } from 'supabaseClient'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useAuth } from './useAuth'

export default function usePlanSubscription() {
  const { user } = useAuth()
  const [subscription, setSubscription] = useState<Subscription | undefined>()

  const fetch = useCallback(async () => {
    const { data } = await supabaseClient
      .from<Subscription>('subscriptions')
      .select('*')
      .eq('user_id', user?.id || null)
      .in('status', ['active'])

    if (data && data?.length > 0) {
      const [sub] = data
      setSubscription(sub)
    }
  }, [user])

  useEffect(() => {
    if (user) {
      fetch()
    }
  }, [fetch, user])

  return useMemo(() => ({ subscription }), [subscription])
}
